<template>
	<fieldset class="coderate_fieldset">
		<legend>{{ language.rateCodeLegend }}</legend>
		<input type="hidden" name="promo" id="promo" v-model="promo">
		<div class="form-row form-row--wide" v-bind:class="{cancellable: isCancellable, editable: !isCancellable}">
			<div class="form-field">
				<label for="coderate_display">{{ language.rateCodeLegend }}</label>
				<input name="coderate_display" id="coderate_display" ref="code" v-model="promo" @focus="onFocus" :placeholder="language.promoCodePH">
				<a href="#" role="button" class="edit-toggle" tabindex="-1" :aria-label="language.editRateCode" @keydown.enter.prevent="enterEditMode" @click.prevent="enterEditMode">{{ language.editRateCode }}</a>
			</div>
			<div class="cancelButton" v-if="isCancellable && usePromo" @click="clearSelection"></div>
		</div>
	</fieldset>
</template>

<script>

export default {
	name: 'RateCode',

	data: function(){
		return {
			dropDownOpen: false,
			timeout: null,
			delay: 522,
		}
	},

	computed: {
		language: function () {
			return this.$store.state.language
		},

		isCancellable: function(){
			return this.usePromo
		},

		usePromo: function(){
			return !!this.$store.state.promo || false
		},

		promo: {
			get() {
				return this.$store.state.promo
			},
			set(value) {
				const that = this
				if(this.timeout) clearTimeout(this.timeout)
				this.timeout = setTimeout(function(){
					that.$store.dispatch('addPromo', {promo: value})
				}, this.delay)
			}
		},
	},

	methods: {

		enterEditMode() {
			this.$nextTick(function(){
				this.$refs.code.focus()
			})
		},

		onFocus() {
			this.$emit('focus')
		},

		selectPromoText(){
			this.$refs.promo.select()
		},

		clearSelection() {
			this.$store.dispatch('chooseRate')
			this.$store.dispatch('addPromo')
		}
	}
}
</script>